<template>
    <div class="recordDetail">
      <Navbar :appTitle="$route.meta.title" @ClickRight="$router.push('/application')"/>

      <!-- 基本信息 -->
      <div class="otherTaps">
        <div class="title">
          <span class="icon"></span>
          <span class="content">报检信息</span>
        </div>
        <div class="content">
          <div class="row">
            <span class="r-label">关联订单：</span>
            <span class="r-column">{{ detailInfo.sellOrderCode || "-" }} </span>
          </div>
          <div class="row">
            <span class="r-label">项目名称：</span>
            <span class="r-column">{{ detailInfo.projectName || "-" }}</span>
          </div>
          <div class="row">
            <span class="r-label">工单编号：</span>
            <span class="r-column">{{detailInfo.orderCode || "-"}}</span>
          </div>
          <div class="row">
            <span class="r-label">生产物品：</span>
            <span class="r-column">{{ detailInfo.serialNumber || "-"}}｜{{detailInfo.serialName||'-'}}| {{detailInfo.serialSpecifications|| '-'}}</span>
          </div>
          <div class="row">
            <span class="r-label">单位：</span>
            <span class="r-column">{{ detailInfo.unitName || '-' }}</span>
          </div>
          <div class="row">
            <span class="r-label" style="width: 106px;">计划生产数量：</span>
            <span class="r-column">{{ detailInfo.planProduceNum || 0 }}</span>
          </div>
          <div class="row">
            <span class="r-label">报检数：</span>
            <span class="r-column">{{ detailInfo.uninspectionNumber || 0 }}</span>
          </div>
          <div class="row">
            <span class="r-label">紧急程度：</span>
            <span class="r-column">{{ detailInfo.urgencyText || "-" }}</span>
          </div>
          <div class="row">
            <span class="r-label">报检描述：</span>
            <span class="r-column">{{ detailInfo.description || "-" }}</span>
          </div>
          <div class="row">
              <span class="r-label">附件：</span>
              <span class="r-column">
                 <span v-if="detailInfo.inspectionAttachments==''">--</span>
                <upload
                  class="fileclass"
                  iconType="fj"
                  @fileChange="fileChange"
                  :fileIds="detailInfo.inspectionAttachments"
                  :showUpload="false"
                ></upload>
              </span>
            </div>
            <div class="row">
            <span class="r-label">报检人：</span>
            <span class="r-column">{{ detailInfo.inspectionByText || '-' }}</span>
            </div>
            <div class="row">
            <span class="r-label">报检时间：</span>
            <span class="r-column">{{ detailInfo.inspectionTime || '-' }}</span>
            </div>
          <!-- <div class="row">
            <span class="r-label">附件：</span>
            {{detailInfo.inspectionAttachments}}
            <file-selector
              ref="fileSelect"
              :maxCount="6"
                title="最多上传6个文件，大小不可超过20M"
                :fileIds="detailInfo.inspectionAttachments"

            ></file-selector>
          </div> -->
          <!-- <van-cell-group>
            <p class="label FormTit"><span></span>附件</p>


          </van-cell-group> -->


        </div>
      </div>

    </div>
  </template>

  <script>
  import upload from "@/components/upload/upload";
  import Navbar from "@/components/navBar/navBar_right";
  import { inspectionTaskId } from "@/api/inspectionTask";
  import {
  formTypeExtendedFieldList,
} from "@/api/mobile";
  export default {
    name: "goodsManagementDetail", //物品详情
    components: { Navbar ,upload},
    data() {
      return {
        detailInfo: {
          extDataJson:[]
        },
        formTypeExtendedFields:[]
      };
    },
    computed: {},
    mounted() {},
    created() {
      this.getDetail();
    },
    methods: {
      fileChange(ids) {
      console.log(ids);
      this.formData.attachment = ids;
    },

     async getDetail() {
      // 获取报工自定义表单字段;
      await formTypeExtendedFieldList({formType: 4}).then((res) => {
        if(res.code == 200 && res.result) {
          this.formTypeExtendedFields = res.result
        }
      });

        let id = this.$route.query.item.id;
        inspectionTaskId({id}).then((res) => {
          if (res.code == 200) {
            this.detailInfo = res.result;
          } else {
            this.$toast(res.message);
          }
        });
      },

    },
  };
  </script>
  <style lang="scss" scoped>

  .recordDetail {
    height: 100vh;
    //   overflow-y: scroll;
    .d-head {
      width: 100%;
      padding: 32px;
      background: #ffffff;
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          width: 560px;
          // border: 1px solid red;
          .title {
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #191f25;
            line-height: 44px;

            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
          .row {
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #888888;
            margin-top: 20px;
          }
        }
        .right {
          // border: 1px solid red;
          width: 120px;
          .rightImg {
            display: block;
            width: 110px;
            height: 110px;
            //   margin-left: 0.45rem;
            // border: 1px solid blue;
          }
        }
      }
    }

    .otherTaps {
      background: #ffffff;
      padding: 32px;
      margin-top: 20px;
      .title {
        padding-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
        .icon {
          display: inline-block;
          width: 6px;
          height: 28px;
          background: #1890ff;
        }
        .content {
          width: 126px;
          height: 32px;
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #191f25;
          line-height: 44px;
          margin-left: 20px;
        }
      }
      .content {
        .row {
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          margin-top: 32px;
          display: flex;
          .r-label {
            color: #888888;
            display: block;
            // max-width: 5rem;
            word-break: break-word;
            // width: 0.7rem;
            //   border: 1px solid red;
          }
          .r-column {
            display: block;
            color: #191f25;
            width: 500px;
            //   border: 1px solid red;
            //    width: 1rem;
          }
        }
        .fhrow {
          display: flex;
          .fhImg {
            width: 110px;
            height: 110px;
            border-radius: 20px;
          }
          .rt-column {
            width: 510px;
            //   height: 2.55rem;
            margin-left: 40px;
            .rt-title {
              font-size: 32px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #191f25;
              margin-bottom: 32px;
            }
            .rt-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 46px;
              .column {
                //    border: 1px solid red;
                width: 300px;
                .column-t {
                  font-size: 28px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #888888;
                  display: block;
                  width: 100%;
                  margin-bottom: 6px;
                }
                .column-c {
                  font-size: 32px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #191f25;
                  display: block;
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }
    .search-bottom {
      height: 100px;
      width: 100%;
      background: #ffffff;
      // background: red;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      bottom: 0px;
      padding: 22px;
      .btnconfirm {
        width: 344px;
        height: 78px;
        background: #1890ff;
        border-radius: 0px;
        text-align: center;
        line-height: 78px;
        color: #ffffff;
      }
      .btncancel {
        width: 344px;
        height: 78px;
        background: #f6f6f6;
        border: 2px solid rgba(25, 31, 37, 0.12);
        border-radius: 0;
        text-align: center;
        line-height: 78px;
      }
    }
  }
  .contentBox {
    margin-top: 276px;
  }

  .otherMargin {
    height: 20px;
    background: #f5f5f5;
  }
  .bottomLine {
    height: 2px;
    background-color: #f0f0f0;
    margin: 32px 32px 0 32px;
  }
  .ExamineBottom {
    height: 100px;
  }
  .status {
    display: inline-block;
    margin-top: 32px;
    padding: 6px 16px;
    background: #edf6ff;
    border-radius: 4px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3774ac;
  }
  </style>
